import { Provider } from '@angular/core';
import { of } from 'rxjs';
import { OrganisationService } from '../organisation.service';

function buildMockOrganisationServiceDefaults(): Partial<OrganisationService> {
  return {
    organisation$: of(undefined),
    brand$: of(undefined),
    practice$: of(undefined),
    user$: of(undefined),
    staffer$: of(undefined),
    stafferSettings$: of(undefined),
    managementStaff$: of([]),
    staff$: of([]),
    userPermissions$: of([]),
    region$: of(undefined),
    userBrands$: of([]),
    userPractices$: of([]),
    practices$: of([]),
    optInFeatures$: of([]),
    hasMultiplePractices$: of(false),
    isSingleBrand$: of(false),
    allUserPractices$: of([]),
    brandPractitioners$: of([]),
    practicePractitioners$: of([]),
    prescribers$: of([]),
    userCol$: of(undefined),
    users$: of([]),
    userMap$: of({}),
    stafferMap$: of({}),
    storagePath$: of(undefined),
    taxRate$: of(undefined),
    selectBrand: jest.fn(),
    selectPractice: jest.fn(),
    switchUser: jest.fn().mockResolvedValue(undefined),
    resolveUser$: jest.fn(() => of(undefined)),
    userHasPermission$: jest.fn(() => of(false)),
  };
}

export function MockOrganisationServiceProvider(
  overrides: Partial<OrganisationService> = {}
): Provider {
  return {
    provide: OrganisationService,
    useValue: {
      ...buildMockOrganisationServiceDefaults(),
      ...overrides,
    },
  };
}
